import AbstractAPI from '@/services/api/AbstractAPI';

export default class CoverageApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/coverage');
  }

  get() {
    return this.makeRequest('/', 'get');
  }

  async update(name, id) {
    return this.makeRequest(`/update/${id}`, 'put', {name});
  }

  async create(name) {
    return this.makeRequest('/create', 'post', {name});
  }

  async delete(id) {
    return this.makeRequest(`/delete/${id}`, 'delete');
  }

  async getWorkTypes(id) {
    return this.makeRequest(`/work-types/${id}`, 'get');
  }

  async updateWorkTypes(id, data) {
    return this.makeRequest(`/work-types/${id}`, 'put', data);
  }

  async getPostCodes(id) {
    return this.makeRequest(`/postcodes/${id}`, 'get');
  }

  async updatePostCodes(id, data) {
    return this.makeRequest(`/postcodes/${id}`, 'put', data);
  }
}
